import React from "react";
import { Outlet } from "react-router-dom";
import { Box, Container } from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

const MainLayout = () => {
  return (
    <>
      <SEO />
      <Box display="flex" flexDirection="column" minHeight="100vh">
        {/* Top Navbar */}
        <Navbar />

        <Outlet />

        {/* Footer */}
        <Footer />
      </Box>
    </>
  );
};

export default MainLayout;